import { SET_SHOP_MODE, ShopMode, SetShopModeAction } from '../types/shopMode.types';

export const setShopMode = (mode: ShopMode): SetShopModeAction => ({
  type: SET_SHOP_MODE,
  payload: mode,
});
